import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';
import BannerAzyekosLounges from '../../components/Carousel/BannerAzyekosLounges';
import MainContainerAZLG from '../../components/Carousel/MainContainerAZLG';
import MainContainerAZLG2 from '../../components/Carousel/MainContainerAZLG2';
import MenusAzyekosL from '../../components/Menuslg/MenusAzyekosL';
import GalerieSection from '../../components/Galeries/GalerieSection';

const colors = {
  bg: '#FFFFFF',
  gold: '#C69C6D',
  goldDark: '#B88A56',
};

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const AzyekosLounges = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .lounges-page {
          background: ${colors.bg};
          min-height: 100vh;
          position: relative;
          overflow: hidden;
        }

        /* Halos dorés subtils en fond */
        .lounges-page::before,
        .lounges-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.15;
          z-index: 0;
          pointer-events: none;
        }

        .lounges-page::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .lounges-page::after {
          width: 40vw;
          height: 40vw;
          background: #EAD5C0;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .content-wrapper {
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .lounges-page::before {
            width: 70vw;
            height: 70vw;
          }
          .lounges-page::after {
            width: 60vw;
            height: 60vw;
          }
        }
      `}</style>


      <Header />

      <motion.div
        className="lounges-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        <div className="content-wrapper">
          <BannerAzyekosLounges />
          <MainContainerAZLG />
          <MainContainerAZLG2 />
          <MenusAzyekosL />
          <GalerieSection />
        </div>
      </motion.div>

      <Footer />
    </>
  );
};

export default AzyekosLounges;